import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NgxCsvParser } from 'ngx-csv-parser';

@Injectable({
  providedIn: 'root',
})
export class QuizGameService {
  quizList: any[] = [];

  constructor(private http: HttpClient, private ngxCsvParser: NgxCsvParser) {}

  getQuizList(csvPath?: string) {
    const path = csvPath ? csvPath : 'assets/data/quiz-list.csv';

    return this.http.get(path, { responseType: 'text' }).pipe(
      map((data) => {
        const rows: string[][] = this.ngxCsvParser.csvStringToArray(data, ',');
        for (const row of rows.filter((r) => r && r[0] && r[1])) {
          // ID, Serial No, Language, TC 繁體, SC 簡體, EN English,
          // Category, Question, Correct Answer, Answer 1, Answer 2, Answer 3, Answer 4, Answer 5, Answer 6, Answer 7, Answer 8

          if (this.quizList.findIndex((q) => q.serial === row[1].trim()) === -1) {
            const tmp = {
              serial: row[1].trim(),
              cat: '',
              questionTc: '',
              questionSc: '',
              questionEn: '',
              corrAnsTc: '',
              corrAnsSc: '',
              corrAnsEn: '',
              ansTc: [],
              ansSc: [],
              ansEn: [],
              blockHeightTc: '',
              blockHeightSc: '',
              blockHeightEn: '',
            };
            this.quizList.push(tmp);
          }

          const idx = this.quizList.findIndex((q) => q.serial === row[1].trim());
          this.quizList[idx].cat = row[3].trim();

          switch (row[2].trim().toUpperCase()) {
            case 'TC':
              this.quizList[idx].questionTc = row[4].trim();
              this.quizList[idx].corrAnsTc = row[5].trim();
              for (let i = 6; i <= 13; i++) {
                if (row[i].trim()) {
                  this.quizList[idx].ansTc.push(row[i].trim());
                }
              }
              this.quizList[idx].blockHeightTc = row[14].trim().toLowerCase();
              break;
            case 'SC':
              this.quizList[idx].questionSc = row[4].trim();
              this.quizList[idx].corrAnsSc = row[5].trim();
              for (let i = 6; i <= 13; i++) {
                if (row[i].trim()) {
                  this.quizList[idx].ansSc.push(row[i].trim());
                }
              }
              this.quizList[idx].blockHeightSc = row[14].trim().toLowerCase();
              break;
            case 'EN':
              this.quizList[idx].questionEn = row[4].trim();
              this.quizList[idx].corrAnsEn = row[5].trim();
              for (let i = 6; i <= 13; i++) {
                if (row[i].trim()) {
                  this.quizList[idx].ansEn.push(row[i].trim());
                }
              }
              this.quizList[idx].blockHeightEn = row[14].trim().toLowerCase();
              break;
          }
        }

        return this.quizList;
      }),
    );
  }
}
